export const URL = "https://apiv2.pooplogg.com/api/v1/client";
export const URL2 = "https://apiv2.pooplogg.com/api";
// Existing screens still import BaseUrl. Keep it as an alias while routing
// every customer API request through the current Go API deployment.
export const BaseUrl = URL;
export const BaseUrl2 = "https://data-entry-api-5hx0.onrender.com/api/v1";
export const CONFIG = {
  headers: {
    "Content-Type": "application/json",
    Authorization: JSON.parse(localStorage.getItem("authData")),
  },
};
